import * as Yup from 'yup';

export const LoginValidacao = Yup.object().shape({
  email: Yup.string()
    .email('Informe um email válido!')
    .required('Você precisa informar esse campo!'),
  senha: Yup.string().required('Você precisa informar esse campo!'),
});
